import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import moment from 'moment'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import translations from "@/resources/translations"
import VueSweetalert2 from 'vue-sweetalert2'
import * as idb from 'idb';
import VueSession from 'vue-session'
import VueMeta from 'vue-meta'
import VueSignaturePad from 'vue-signature-pad'
import Maska from 'maska'


var options = {
    persist: true
}

Vue.use(VueSession, options)
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(VueSweetalert2);
Vue.use(VueMeta);
Vue.use(VueSignaturePad);
Vue.use(Maska);


Vue.prototype.moment = moment;

var i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: translations
});

// Minimum requirements:
// 1.0.174 - [Pacific] Added Schedule of Client Provided Information multiselection dropdown for FDR
// 1.0.173 - [QFPC] Enabled Site Plans functionality for FDR
// 1.0.172 - [QFPC] Addition of editable "Prepared by" and "Edited by" fields for FDR
// 1.0.170 - [QFPC] Support for original_author_id field for FDR to allow "Edited by" feature
// 1.0.169 - Fix search feature for various reports when at least one of checked fields is null
// 1.0.168 - [Pacific] Added Door & Half Leaf as option for double door (gaps fields validation)
// 1.0.167 - [Pacifc] Fix issue with Door Inspected By not being hightlighted as invalid when no value is provided for it
// 1.0.166 - [Pacific] Fixed Mark Complete button issue caused by removing delete report buttons
// 1.0.164 - [Pacific] Removed delete report buttons, added Door Inspected By field (FDR)
// 1.0.162 - JP Fire - back button prompt
// 1.0.159 - FRA changes for JP Fire (Feb 24), added handling demo workspace
// 1.0.158 - Fixed issue with pin numbers when cloning door (FDR) or issue (FSR) / fixed displaying Photos After Installation
// 1.0.157 - Glazing Panels Type field for Pacific
// 1.0.156 - Door search field, extra field (FDR), 3rd party FDR (Pacific)
// 1.0.154 - BAE System Report changes
// 1.0.153 - Added site plans to FD reports (Pacific)
// 1.0.152 - Fixed spelling mistakes in BAE Systems Report, fixed default disclaimer for FDR for Scotland based sites (QFPC)
// 1.0.151 - Door Installation Reports & Door Maintenance Reports
// 1.0.150 - Fixed loading options for BM Trada fields for QFPC
// 1.0.149 - Fixed missing BM Trada fields for QFPC
// 1.0.148 - Fixed BM Trada template for QFPC, added inspector signature field for them
// 1.0.147 - BAE Systems Reports, QFPC changes to Fire Door Inspections
// 1.0.146 - Fixed undefined variable issue when cloning FSR item
// 1.0.144 - Fixed undefined variable issue for sites without access to BM Trada template
// 1.0.143 - Added Inspector Signature to door reports (except of JP Fire reports)
// 1.0.142 - Zoom Level for Site Plan
// 1.0.141 - Door Reports - BM Trada template changes
// 1.0.140 - Fire Stopping Reports - Audit section, new fields for services
// 1.0.139 - Extinguisher Report - Tamper Tag fields, conditional BS5306-3 field, weight checked field for extinguisher
// 1.0.137 - Fire Stopping Reports
// 1.0.133 - Added QFPC branding
// 1.0.131 - [Fire Door Inspection] Corrected misspelled word for one of gaps measurements fields
// 1.0.130 - [Fire Door Inspection] Glazing panels, substrate type, gaps measurements
// 1.0.128 - [Extinguisher Report] Manual input with mask for extended service date field
// 1.0.127 - [Risk Audit / Door Check] Added client & engineer signatures
// 1.0.125 - [Risk Audit] Multiple photos selection for questions
// 1.0.123 - [Extinguisher Report] Client signature: name and date
// 1.0.122 - [Extinguisher Report] Added 'Other option for extinguisher type, capacity, position, finish'
// 1.0.121 - [Extinguisher Report] Added 3rd value for extinguisher status
// 1.0.120 - [Risk Audit] Added photos to each question
// 1.0.115 - Added risk audits
// 1.0.112 - New sync mechanism for Door Checks / Risk Audits; EXIF data handling
// 1.0.100 - Risk Audit - Fix bug for qn 2.4
// 1.0.99 - Risk Audit - Changed behaviour of extra dropdowns for qns 4.4 and 4.14, added dropdown for qn 2.4
// 1.0.98 - Risk Audit - Added icon next to hide question checkboxes
// 1.0.97 - Risk Audit - fixed issue with editing existing reports created with version 1.0.93 and older
// 1.0.95 - Risk Audit - updated questions, added hide question checkboxes, added dropdowns to questions 4.4 and 4.14
// 1.0.93 - Fixed issue in Risk Audit - entering additional comment for S4.7 resetting value for S4.7 number input
// 1.0.92 - Change to ordering door faults by fault_code - items without fault_code to be displayed at the end of the list
// 1.0.91 - Ordering door faults by fault_code
// 1.0.90 - Added offline_image_id to images to prevent uploading image duplicates
// 1.0.89 - Added rotate buttons for offline images (doors and risk audit reports)
// 1.0.88 - Changing orientation info for iOS after exif bug has been introduced between iOS 13.1.2 and 13.4.1
// 1.0.87 - Fixed bug in method adding pics for risk audit
// 1.0.86 - Changing orientation info for Firefox
// 1.0.85 - Removing offline images for doors, changing orientation info depending on device
// 1.0.83 - Added compressing / resizing images and passing exif data to backend
// 1.0.82 - Fixed issue with displaying preview of local images for doors
// 1.0.81 - Fixed issue with removing EXIF data when uploading door images
// 1.0.80 - Loading default inspector notes per door (only when adding new door)
// 1.0.79 - Fixed issue with removing EXIF data when uploading risk assessment images
// 1.0.78 - Fixed bug preventing faults section to open on Pass/NA/Fail change
// 1.0.77 - Added qty field to door faults
// 1.0.76 - Added checkboxes to YesNoNaButton component (risk audit) to allow auto-populate of action plan
// 1.0.75 - Changed S4.4 field type to free text (was numeric)
// 1.0.74 - Fixed issue with undefined user_token sent to API (resulted in HTTP 403)
// 1.0.73 - Fixed issue with adding cover photo during risk report edit
// 1.0.72 - Removed report_text from S4 for new reports, added multiple file upload. Added ability to take a photo or select it from gallery
// 1.0.70 - Fixed issue with displaying additional comments when editing risk audit (missed few comments fields)
// 1.0.69 - Fixed issue with displaying additional comments when editing risk audit
// 1.0.68 - Fixed issue with risk audit dropdowns not removing deleted options
// 1.0.66 - Fixed issue with overwriting complete status for Risk Audit
// 1.0.64 - Updated dropdowns for Risk Audit to be single selection and append selected value to textarea
// 1.0.63 - Fixed issue with dropdowns for Risk Audit (textarea made read-only when dropdown is present)
// 1.0.59 - Fixed duplicated question S17.2 used for S17.3
// 1.0.57 - Fixed YesNoNa buttons not setting their values when editing Risk Audit
// 1.0.42 - Don't duplicate offline image upload
// 1.0.39 - PDF Links
// 1.0.36 - Ability to reload app
// 1.0.33 - Risk Audits alpha. New syncs (separated into distinct syncs, "last updated" in session rather than DB)
// 1.0.31 - Improvements - clone doesn't include images, change in door add layout
// 1.0.29 -  !! This was accidentally reversed with new sync operations. Go to 1.0.42 !! Original message -> Don't duplicate offline image upload
// 1.0.25 - Risk audit sync
// 1.0.22 = Correctly save faults
// 1.0.15 - Risk audit tables
// 1.0.13 - PDFs open in iOS
// 1.0.12 - Barcode and dimensions not required fields
// 1.0.11 - Offline images is default option
// 1.0.7 - Offline images
// 1.0.6 - Improved error recording on initial sync
// 1.0.1 - Auto sync

Vue.mixin({
    data: function () {
        return {
            appName: this.getCmsDetails('appname'),
            cmsUrl: this.getCmsDetails('url'),
            dbName: this.getCmsDetails('dbname'),
            dbVersionNumber: 32,
            appVersionNumber: '1.1.174',
            appNumericVersion: 174
        }
    },
    methods: {
        getDbNew() {
            return new Promise((resolve, reject) => {
                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.");
                    reject('Your browser doesn\'t support a stable version of IndexedDB.');
                }
    
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);
    
                request.onblocked = function(event) {
                    alert('The app needs to be updated, but the app is open elsewhere. Please close all other tabs with this app open and refresh the page.');
                };
    
                request.onerror = function (event) {
                    reject('Failed to open IndexedDB connection');
                };
    
                request.onsuccess = function (event) {
                    resolve(request.result);
                };
    
                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
    
                    if (!db.objectStoreNames.contains('workspace_details')) {
                        var workspaceDetailsStore = db.createObjectStore('workspace_details', {keyPath: 'workspace_id'});
                    }
                    if (!db.objectStoreNames.contains('door_checks')) {
                        var doorChecksStore = db.createObjectStore('door_checks', {keyPath: 'site_door_check_id'});
                    }
                    if (!db.objectStoreNames.contains('door_check_doors')) {
                        var doorCheckDoors = db.createObjectStore('door_check_doors', {keyPath: 'site_door_check_door_id'});
                    }
                    if (!db.objectStoreNames.contains('door_check_site_plans')) {
                        db.createObjectStore('door_check_site_plans', {keyPath: 'site_door_check_site_plan_id'});
                    }
                    if (!db.objectStoreNames.contains('door_check_site_plans_archived')) {
                        db.createObjectStore('door_check_site_plans_archived', {keyPath: 'site_door_check_site_plan_id'});
                    }
                    if (!db.objectStoreNames.contains('door_checks_archived')) {
                        var archivedDoorChecksStore = db.createObjectStore('door_checks_archived', {keyPath: 'site_door_check_id'});
                    }
                    if (!db.objectStoreNames.contains('door_check_doors_archived')) {
                        var archivedDoorCheckDoorsStore = db.createObjectStore('door_check_doors_archived', {keyPath: 'site_door_check_door_id'});
                    }
                    if (!db.objectStoreNames.contains('door_sets')) {
                        var doorSetsStore = db.createObjectStore('door_sets', {keyPath: 'door_set_id'});
                    }
                    if (!db.objectStoreNames.contains('door_materials')) {
                        var doorMaterialsStore = db.createObjectStore('door_materials', {keyPath: 'door_material_id'});
                    }
                    if (!db.objectStoreNames.contains('frame_materials')) {
                        var frameMaterialsStore = db.createObjectStore('frame_materials', {keyPath: 'frame_material_id'});
                    }
                    if (!db.objectStoreNames.contains('locations')) {
                        var locationsStore = db.createObjectStore('locations', {keyPath: 'location_id'});
                    }
                    if (!db.objectStoreNames.contains('door_types')) {
                        var doorTypesStore = db.createObjectStore('door_types', {keyPath: 'door_type_id'});
                    }
                    if (!db.objectStoreNames.contains('door_check_report_configurations')) {
                        var reportConfigurationsStore = db.createObjectStore('door_check_report_configurations', {keyPath: 'door_check_report_configuration_id'});
                    }
                    if (!db.objectStoreNames.contains('door_faults')) {
                        var doorFaultsStore = db.createObjectStore('door_faults', {keyPath: 'door_fault_id'});
                    }
                    if (!db.objectStoreNames.contains('risk_audits')) {
                        var riskAuditsStore = db.createObjectStore('risk_audits', {keyPath: 'risk_audit_id'});
                    }
                    if (!db.objectStoreNames.contains('risk_assessments')) {
                        var riskAssessmentsStore = db.createObjectStore('risk_assessments', {keyPath: 'site_risk_audit_id'});
                    }
                    if (!db.objectStoreNames.contains('risk_assessments_archived')) {
                        var archivedRiskAssessmentsStore = db.createObjectStore('risk_assessments_archived', {keyPath: 'site_risk_audit_id'});
                    }
                    if (!db.objectStoreNames.contains('risk_audit_action_plans')) {
                        var riskAuditActionPlansStore = db.createObjectStore('risk_audit_action_plans', {keyPath: 'risk_audit_action_plan_id'});
                    }
                    if (!db.objectStoreNames.contains('dropdowns')) {
                        var dropdownsStore = db.createObjectStore('dropdowns', {keyPath: 'dropdown_id'});
                        dropdownsStore.createIndex('question_id', 'question_id', { unique: false });
                    }
                    if (db.objectStoreNames.contains('dropdowns')) {
                        var tx = event.target.transaction;
    
                        var ddStore = tx.objectStore('dropdowns');
    
                        if (!ddStore.indexNames.contains('question_id')) {
                            var ddCreateIndex = ddStore.createIndex('question_id', 'question_id', { unique: false });
                            ddCreateIndex.onsuccess = function(event) {
                            }
                            ddCreateIndex.onerror = function(error) {
                                console.log('Problem creating index', error)
                            }
                        }
                    }
                    if (!db.objectStoreNames.contains('fra_report_types')) {
                        db.createObjectStore('fra_report_types', {keyPath: 'fra_report_type_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_reports')) {
                        db.createObjectStore('extinguisher_reports', {keyPath: 'site_extinguisher_report_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_reports_archived')) {
                        db.createObjectStore('extinguisher_reports_archived', {keyPath: 'site_extinguisher_report_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_report_items')) {
                        db.createObjectStore('extinguisher_report_items', {keyPath: 'site_extinguisher_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_report_items_archived')) {
                        db.createObjectStore('extinguisher_report_items_archived', {keyPath: 'site_extinguisher_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_capacities')) {
                        db.createObjectStore('extinguisher_capacities', {keyPath: 'extinguisher_capacity_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_finishes')) {
                        db.createObjectStore('extinguisher_finishes', {keyPath: 'extinguisher_finish_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_positions')) {
                        db.createObjectStore('extinguisher_positions', {keyPath: 'extinguisher_position_id'});
                    }
                    if (!db.objectStoreNames.contains('extinguisher_types')) {
                        db.createObjectStore('extinguisher_types', {keyPath: 'extinguisher_type_id'});
                    }
                    if (!db.objectStoreNames.contains('substrate_types')) {
                        db.createObjectStore('substrate_types', {keyPath: 'substrate_type_id'});
                    }
                    if (!db.objectStoreNames.contains('fire_stopping_reports')) {
                        db.createObjectStore('fire_stopping_reports', {keyPath: 'site_fire_stopping_report_id'});
                    }
                    if (!db.objectStoreNames.contains('fire_stopping_reports_archived')) {
                        db.createObjectStore('fire_stopping_reports_archived', {keyPath: 'site_fire_stopping_report_id'});
                    }
                    if (!db.objectStoreNames.contains('fire_stopping_report_site_plans')) {
                        db.createObjectStore('fire_stopping_report_site_plans', {keyPath: 'site_fire_stopping_report_site_plan_id'});
                    }
                    if (!db.objectStoreNames.contains('fire_stopping_report_site_plans_archived')) {
                        db.createObjectStore('fire_stopping_report_site_plans_archived', {keyPath: 'site_fire_stopping_report_site_plan_id'});
                    }
                    if (!db.objectStoreNames.contains('fire_stopping_report_items')) {
                        db.createObjectStore('fire_stopping_report_items', {keyPath: 'site_fire_stopping_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('fire_stopping_report_items_archived')) {
                        db.createObjectStore('fire_stopping_report_items_archived', {keyPath: 'site_fire_stopping_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('fsr_faults')) {
                        db.createObjectStore('fsr_faults', {keyPath: 'fsr_fault_id'});
                    }
                    if (!db.objectStoreNames.contains('fsr_materials')) {
                        db.createObjectStore('fsr_materials', {keyPath: 'fsr_material_id'});
                    }
                    if (!db.objectStoreNames.contains('fsr_required_fire_ratings')) {
                        db.createObjectStore('fsr_required_fire_ratings', {keyPath: 'fsr_required_fire_rating_id'});
                    }
                    if (!db.objectStoreNames.contains('fsr_substrate_types')) {
                        db.createObjectStore('fsr_substrate_types', {keyPath: 'fsr_substrate_type_id'});
                    }
                    if (!db.objectStoreNames.contains('fsr_construction_types')) {
                        db.createObjectStore('fsr_construction_types', {keyPath: 'fsr_construction_type_id'});
                    }
                    if (!db.objectStoreNames.contains('fsr_thermal_insulations')) {
                        db.createObjectStore('fsr_thermal_insulations', {keyPath: 'fsr_thermal_insulation_id'});
                    }
                    if (!db.objectStoreNames.contains('fsr_products')) {
                        db.createObjectStore('fsr_products', {keyPath: 'fsr_product_id'});
                    }
                    if (!db.objectStoreNames.contains('declared_resistance_levels')) {
                        db.createObjectStore('declared_resistance_levels', {keyPath: 'declared_resistance_level_id'});
                    }
                    if (!db.objectStoreNames.contains('level_options')) {
                        db.createObjectStore('level_options', {keyPath: 'level_option_id'});
                    }
                    if (!db.objectStoreNames.contains('bae_systems_reports')) {
                        db.createObjectStore('bae_systems_reports', {keyPath: 'site_bae_systems_report_id'});
                    }
                    if (!db.objectStoreNames.contains('bae_systems_reports_archived')) {
                        db.createObjectStore('bae_systems_reports_archived', {keyPath: 'site_bae_systems_report_id'});
                    }
                    if (!db.objectStoreNames.contains('door_installation_reports')) {
                        db.createObjectStore('door_installation_reports', {keyPath: 'site_door_installation_report_id'});
                    }
                    if (!db.objectStoreNames.contains('door_installation_reports_archived')) {
                        db.createObjectStore('door_installation_reports_archived', {keyPath: 'site_door_installation_report_id'});
                    }
                    if (!db.objectStoreNames.contains('door_installation_report_items')) {
                        db.createObjectStore('door_installation_report_items', {keyPath: 'site_door_installation_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('door_installation_report_items_archived')) {
                        db.createObjectStore('door_installation_report_items_archived', {keyPath: 'site_door_installation_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('door_maintenance_reports')) {
                        db.createObjectStore('door_maintenance_reports', {keyPath: 'site_door_maintenance_report_id'});
                    }
                    if (!db.objectStoreNames.contains('door_maintenance_reports_archived')) {
                        db.createObjectStore('door_maintenance_reports_archived', {keyPath: 'site_door_maintenance_report_id'});
                    }
                    if (!db.objectStoreNames.contains('door_maintenance_report_items')) {
                        db.createObjectStore('door_maintenance_report_items', {keyPath: 'site_door_maintenance_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('door_maintenance_report_items_archived')) {
                        db.createObjectStore('door_maintenance_report_items_archived', {keyPath: 'site_door_maintenance_report_item_id'});
                    }
                    if (!db.objectStoreNames.contains('client_defined_ratings')) {
                        db.createObjectStore('client_defined_ratings', {keyPath: 'client_defined_rating_id'});
                    }
                    if (!db.objectStoreNames.contains('cpi_schedule_items')) {
                        db.createObjectStore('cpi_schedule_items', {keyPath: 'cpi_schedule_item_id'});
                    }
                };
            });
        },
        getDb(callbackFunction) {
            if (!window.indexedDB) {
                window.alert("Your browser doesn't support a stable version of IndexedDB.")
            }

            var db;
            var dbName = this.getCmsDetails('dbname');
            var request = window.indexedDB.open(dbName, this.dbVersionNumber);

            request.onblocked = function(event) {
                alert('The app needs to be updated, but the app is open elsewhere. Please close all other tabs with this app open and refresh the page.');
            };

            request.onerror = function (event) {
            };

            request.onsuccess = function (event) {
                db = request.result;
                callbackFunction(db);
            };

            request.onupgradeneeded = function (event) {
                var db = event.target.result;

                if (!db.objectStoreNames.contains('workspace_details')) {
                    var workspaceDetailsStore = db.createObjectStore('workspace_details', {keyPath: 'workspace_id'});
                }
                if (!db.objectStoreNames.contains('door_checks')) {
                    var doorChecksStore = db.createObjectStore('door_checks', {keyPath: 'site_door_check_id'});
                }
                if (!db.objectStoreNames.contains('door_check_doors')) {
                    var doorCheckDoors = db.createObjectStore('door_check_doors', {keyPath: 'site_door_check_door_id'});
                }
                if (!db.objectStoreNames.contains('door_checks_archived')) {
                    var archivedDoorChecksStore = db.createObjectStore('door_checks_archived', {keyPath: 'site_door_check_id'});
                }
                if (!db.objectStoreNames.contains('door_check_doors_archived')) {
                    var archivedDoorCheckDoorsStore = db.createObjectStore('door_check_doors_archived', {keyPath: 'site_door_check_door_id'});
                }
                if (!db.objectStoreNames.contains('door_check_site_plans')) {
                    db.createObjectStore('door_check_site_plans', {keyPath: 'site_door_check_site_plan_id'});
                }
                if (!db.objectStoreNames.contains('door_check_site_plans_archived')) {
                    db.createObjectStore('door_check_site_plans_archived', {keyPath: 'site_door_check_site_plan_id'});
                }
                if (!db.objectStoreNames.contains('door_sets')) {
                    var doorSetsStore = db.createObjectStore('door_sets', {keyPath: 'door_set_id'});
                }
                if (!db.objectStoreNames.contains('door_materials')) {
                    var doorMaterialsStore = db.createObjectStore('door_materials', {keyPath: 'door_material_id'});
                }
                if (!db.objectStoreNames.contains('frame_materials')) {
                    var frameMaterialsStore = db.createObjectStore('frame_materials', {keyPath: 'frame_material_id'});
                }
                if (!db.objectStoreNames.contains('locations')) {
                    var locationsStore = db.createObjectStore('locations', {keyPath: 'location_id'});
                }
                if (!db.objectStoreNames.contains('door_types')) {
                    var doorTypesStore = db.createObjectStore('door_types', {keyPath: 'door_type_id'});
                }
                if (!db.objectStoreNames.contains('door_check_report_configurations')) {
                    var reportConfigurationsStore = db.createObjectStore('door_check_report_configurations', {keyPath: 'door_check_report_configuration_id'});
                }
                if (!db.objectStoreNames.contains('door_faults')) {
                    var doorFaultsStore = db.createObjectStore('door_faults', {keyPath: 'door_fault_id'});
                }
                if (!db.objectStoreNames.contains('risk_audits')) {
                    var riskAuditsStore = db.createObjectStore('risk_audits', {keyPath: 'risk_audit_id'});
                }
                if (!db.objectStoreNames.contains('risk_assessments')) {
                    var riskAssessmentsStore = db.createObjectStore('risk_assessments', {keyPath: 'site_risk_audit_id'});
                }
                if (!db.objectStoreNames.contains('risk_assessments_archived')) {
                    var archivedRiskAssessmentsStore = db.createObjectStore('risk_assessments_archived', {keyPath: 'site_risk_audit_id'});
                }
                if (!db.objectStoreNames.contains('risk_audit_action_plans')) {
                    var riskAuditActionPlansStore = db.createObjectStore('risk_audit_action_plans', {keyPath: 'risk_audit_action_plan_id'});
                }
                if (!db.objectStoreNames.contains('dropdowns')) {
                    var dropdownsStore = db.createObjectStore('dropdowns', {keyPath: 'dropdown_id'});
                    dropdownsStore.createIndex('question_id', 'question_id', { unique: false });
                }
                if (db.objectStoreNames.contains('dropdowns')) {
                    var tx = event.target.transaction;

                    var ddStore = tx.objectStore('dropdowns');

                    if (!ddStore.indexNames.contains('question_id')) {
                        var ddCreateIndex = ddStore.createIndex('question_id', 'question_id', { unique: false });
                        ddCreateIndex.onsuccess = function(event) {
                        }
                        ddCreateIndex.onerror = function(error) {
                            console.log('Problem creating index', error)
                        }
                    }
                }
                if (!db.objectStoreNames.contains('fra_report_types')) {
                    db.createObjectStore('fra_report_types', {keyPath: 'fra_report_type_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_reports')) {
                    db.createObjectStore('extinguisher_reports', {keyPath: 'site_extinguisher_report_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_reports_archived')) {
                    db.createObjectStore('extinguisher_reports_archived', {keyPath: 'site_extinguisher_report_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_report_items')) {
                    db.createObjectStore('extinguisher_report_items', {keyPath: 'site_extinguisher_report_item_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_report_items_archived')) {
                    db.createObjectStore('extinguisher_report_items_archived', {keyPath: 'site_extinguisher_report_item_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_capacities')) {
                    db.createObjectStore('extinguisher_capacities', {keyPath: 'extinguisher_capacity_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_finishes')) {
                    db.createObjectStore('extinguisher_finishes', {keyPath: 'extinguisher_finish_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_positions')) {
                    db.createObjectStore('extinguisher_positions', {keyPath: 'extinguisher_position_id'});
                }
                if (!db.objectStoreNames.contains('extinguisher_types')) {
                    db.createObjectStore('extinguisher_types', {keyPath: 'extinguisher_type_id'});
                }
                if (!db.objectStoreNames.contains('substrate_types')) {
                    db.createObjectStore('substrate_types', {keyPath: 'substrate_type_id'});
                }
                if (!db.objectStoreNames.contains('fire_stopping_reports')) {
                    db.createObjectStore('fire_stopping_reports', {keyPath: 'site_fire_stopping_report_id'});
                }
                if (!db.objectStoreNames.contains('fire_stopping_reports_archived')) {
                    db.createObjectStore('fire_stopping_reports_archived', {keyPath: 'site_fire_stopping_report_id'});
                }
                if (!db.objectStoreNames.contains('fire_stopping_report_site_plans')) {
                    db.createObjectStore('fire_stopping_report_site_plans', {keyPath: 'site_fire_stopping_report_site_plan_id'});
                }
                if (!db.objectStoreNames.contains('fire_stopping_report_site_plans_archived')) {
                    db.createObjectStore('fire_stopping_report_site_plans_archived', {keyPath: 'site_fire_stopping_report_site_plan_id'});
                }
                if (!db.objectStoreNames.contains('fire_stopping_report_items')) {
                    db.createObjectStore('fire_stopping_report_items', {keyPath: 'site_fire_stopping_report_item_id'});
                }
                if (!db.objectStoreNames.contains('fire_stopping_report_items_archived')) {
                    db.createObjectStore('fire_stopping_report_items_archived', {keyPath: 'site_fire_stopping_report_item_id'});
                }
                if (!db.objectStoreNames.contains('fsr_faults')) {
                    db.createObjectStore('fsr_faults', {keyPath: 'fsr_fault_id'});
                }
                if (!db.objectStoreNames.contains('fsr_materials')) {
                    db.createObjectStore('fsr_materials', {keyPath: 'fsr_material_id'});
                }
                if (!db.objectStoreNames.contains('fsr_required_fire_ratings')) {
                    db.createObjectStore('fsr_required_fire_ratings', {keyPath: 'fsr_required_fire_rating_id'});
                }
                if (!db.objectStoreNames.contains('fsr_substrate_types')) {
                    db.createObjectStore('fsr_substrate_types', {keyPath: 'fsr_substrate_type_id'});
                }
                if (!db.objectStoreNames.contains('fsr_construction_types')) {
                    db.createObjectStore('fsr_construction_types', {keyPath: 'fsr_construction_type_id'});
                }
                if (!db.objectStoreNames.contains('fsr_thermal_insulations')) {
                    db.createObjectStore('fsr_thermal_insulations', {keyPath: 'fsr_thermal_insulation_id'});
                }
                if (!db.objectStoreNames.contains('fsr_products')) {
                    db.createObjectStore('fsr_products', {keyPath: 'fsr_product_id'});
                }
                if (!db.objectStoreNames.contains('declared_resistance_levels')) {
                    db.createObjectStore('declared_resistance_levels', {keyPath: 'declared_resistance_level_id'});
                }
                if (!db.objectStoreNames.contains('level_options')) {
                    db.createObjectStore('level_options', {keyPath: 'level_option_id'});
                }

                if (!db.objectStoreNames.contains('bae_systems_reports')) {
                    db.createObjectStore('bae_systems_reports', {keyPath: 'site_bae_systems_report_id'});
                }
                if (!db.objectStoreNames.contains('bae_systems_reports_archived')) {
                    db.createObjectStore('bae_systems_reports_archived', {keyPath: 'site_bae_systems_report_id'});
                }
                if (!db.objectStoreNames.contains('door_installation_reports')) {
                    db.createObjectStore('door_installation_reports', {keyPath: 'site_door_installation_report_id'});
                }
                if (!db.objectStoreNames.contains('door_installation_reports_archived')) {
                    db.createObjectStore('door_installation_reports_archived', {keyPath: 'site_door_installation_report_id'});
                }
                if (!db.objectStoreNames.contains('door_installation_report_items')) {
                    db.createObjectStore('door_installation_report_items', {keyPath: 'site_door_installation_report_item_id'});
                }
                if (!db.objectStoreNames.contains('door_installation_report_items_archived')) {
                    db.createObjectStore('door_installation_report_items_archived', {keyPath: 'site_door_installation_report_item_id'});
                }
                if (!db.objectStoreNames.contains('door_maintenance_reports')) {
                    db.createObjectStore('door_maintenance_reports', {keyPath: 'site_door_maintenance_report_id'});
                }
                if (!db.objectStoreNames.contains('door_maintenance_reports_archived')) {
                    db.createObjectStore('door_maintenance_reports_archived', {keyPath: 'site_door_maintenance_report_id'});
                }
                if (!db.objectStoreNames.contains('door_maintenance_report_items')) {
                    db.createObjectStore('door_maintenance_report_items', {keyPath: 'site_door_maintenance_report_item_id'});
                }
                if (!db.objectStoreNames.contains('door_maintenance_report_items_archived')) {
                    db.createObjectStore('door_maintenance_report_items_archived', {keyPath: 'site_door_maintenance_report_item_id'});
                }
                if (!db.objectStoreNames.contains('client_defined_ratings')) {
                    db.createObjectStore('client_defined_ratings', {keyPath: 'client_defined_rating_id'});
                }
                if (!db.objectStoreNames.contains('cpi_schedule_items')) {
                    db.createObjectStore('cpi_schedule_items', {keyPath: 'cpi_schedule_item_id'});
                }
            };
        },
        getCmsDetails(option) {
            var subdomain = this.getSubdomain(window.location.hostname);
            if (subdomain === undefined || subdomain === null || subdomain === '') {
                 if (option === 'url') {
                    //return 'https://dev.assessment-app.switchstancehq.com/';
                    return 'http://dev.dev.fire-assessment-app.local/';
                 } else if (option === 'dbname') {
                     return 'dev';
                 } else if (option === 'appname') {
                     return 'Dev';
                 }
            } else {
                if (option === 'url') {
                    if(window.location.hostname == 'dev.fireapp.switchstancehq.com') {
                        return 'https://dev.fireapp-admin.switchstancehq.com/';
                    } else if(window.location.hostname == 'qfpc.fireapp.switchstancehq.com') {
                        return 'https://qfpc.fireapp-admin.switchstancehq.com/';
                    } else if(window.location.hostname == 'demo.fireapp.switchstancehq.com') {
                        return 'https://demo.fireapp-admin.switchstancehq.com/';
                    } else if(window.location.hostname == 'jpfire.fireapp.switchstancehq.com') {
                        return 'https://jpfire.fireapp-admin.switchstancehq.com/';
                    }
                    return 'https://' + subdomain + '.assessment-app.switchstancehq.com/';
                } else if (option === 'dbname') {
                    return subdomain;
                } else if (option === 'appname') {
                    return subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
                }
            }
        },
        getCmsUrl() {
            return this.getCmsDetails('dbname')
        },
        getSubdomain(hostname) {
            var regexParse = new RegExp('[a-z\-0-9]{2,63}\.[a-z\.]{2,5}$');
            var urlParts = regexParse.exec(hostname);
            if (urlParts !== null) {
                var subdomains = hostname.replace(urlParts[0], '').slice(0, -1);
                return subdomains.split('.')[0];
            }
            return null;
        }
    }
});

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});

Vue.filter('formatDateTime', function (value) {
    if (value) {
        return moment(String(value)).format('HH:mm DD/MM/YYYY');
    }
});



Vue.filter('nextAutoSync', function (value) {
    if (value) {
        var autoScheduleTime = moment(value).add(30, 'minutes');
        return autoScheduleTime.fromNow();
    }
});

Vue.config.productionTip = false;



new Vue({
    router,
    moment,
    render: h => h(App)
}).$mount('#app');



